import { isExternalUrl } from './is-external';

export function getExternalUrl(
	url: string,
	options: { internalRoutes: readonly RegExp[]; forceMode?: 'internal' | 'external' },
): string | undefined {
	return isExternalUrl(url, options) ? url : undefined;
}
